// iter414 — Branch Loss Alerts card extracted from DashboardPage.jsx
// Renders a red-bordered card listing branches whose period expenses
// exceeded their sales (loss = sales - expenses). Hidden when no
// alerts. Used inside the dashboard "Alerts" DashboardSection.
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle } from 'lucide-react';
import { RiyalIcon } from '@/lib/currency';

export function BranchLossAlertsCard({ alerts = [] }) {
  if (!alerts.length) return null;
  return (
    <Card className="border-error/50 bg-error/5" data-testid="branch-loss-alerts">
      <CardHeader>
        <CardTitle className="font-outfit flex items-center gap-2 text-error">
          <AlertTriangle size={18} />Branch Loss Alert
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {alerts.map((a, i) => (
            <div
              key={`${a.branch}-${i}`}
              className="flex justify-between items-center p-3 bg-background rounded-xl border border-error/20"
              data-testid={`branch-loss-alert-${i}`}
            >
              <div>
                <div className="font-medium text-sm">{a.branch || a.name || '—'}</div>
                <div className="text-xs text-muted-foreground inline-flex items-center gap-0.5">
                  {/* iter535 — null-safe so a single missing field can't crash the entire dashboard */}
                  Sales: <RiyalIcon size="0.85em" /> {Number(a.sales || 0).toFixed(0)} | Expenses: <RiyalIcon size="0.85em" /> {Number(a.expenses || 0).toFixed(0)}
                </div>
              </div>
              <Badge className="bg-error/20 text-error text-sm inline-flex items-center gap-0.5">
                Loss: <RiyalIcon size="0.85em" /> {Math.abs(Number(a.profit || a.net || 0)).toFixed(2)}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export default BranchLossAlertsCard;
